import React, { createContext, useContext, useEffect, useState } from 'react';
import { MunicipalityTasksApi } from 'api';
import { Api } from 'api/cabmun-content-public';
import useUserData from 'hooks/useUserData';

export interface TaskStateValuesProps {
  plate1: Api.GetMunicipalityTasks200Response.Plate1;
  plate2: Api.GetMunicipalityTasks200Response.Plate2;
  plate3: Api.GetMunicipalityTasks200Response.Plate3;
  plate4: Api.GetMunicipalityTasks200Response.Plate4;
}
export interface MunicipalityTaskContextProps {
  values: Api.GetMunicipalityTasks200Response;
  updateMunicipalityTask: (name: string) => void;
  addModal: (name: string) => void;
  closeModal: () => void;
  currentModal: string | null;
  id: number | null;
  userType: string;
}

const defaultValues: TaskStateValuesProps = {
  plate1: {
    status: false,
  },
  plate2: {
    status: false,
    count: 0,
  },
  plate3: {
    status: false,
  },
  plate4: {
    status: false,
  },
};

const defaultValuesContext: MunicipalityTaskContextProps = {
  values: defaultValues,
  updateMunicipalityTask: () => Promise<void>,
  addModal: () => {},
  closeModal: () => {},
  currentModal: null,
  id: null,
  userType: '',
};
const Context = createContext<MunicipalityTaskContextProps>(defaultValuesContext);

const MunicipalityTasksContext = (props: React.PropsWithChildren<{}>) => {
  const [values, setValues] = useState<TaskStateValuesProps>(defaultValues);
  const [modals, setModals] = useState<string[]>([]);
  const [currentModal, setCurrentModal] = useState<string | null>(null);
  const userData = useUserData();
  const id = userData?.id || 0;
  const userType = userData?.userType || '';

  const addModal = (name: string) => {
    setModals([...modals, name]);
  };
  const closeModal = () => {
    setCurrentModal(null);
  };

  useEffect(() => {
    if (!modals.length || currentModal) return;
    setTimeout(() => {
      setCurrentModal(modals[0]);
      setModals(modals.slice(1));
    }, 500);
  }, [modals, currentModal]);

  useEffect(() => {
    if (userData?.id) {
      getMunicipalityTasks();
    }
  }, [userData?.id]);

  const getMunicipalityTasks = async (name?: string) => {
    try {
      const { plate1, plate2, plate3, plate4 } = await MunicipalityTasksApi.getMunicipalityTasks();
      setValues({
        ...values,
        plate1: plate1!,
        plate2: plate2!,
        plate3: plate3!,
        plate4: plate4!,
      });
    } catch (error) {
    } finally {
    }
  };

  const updateMunicipalityTask = async (name: string) => {
    await MunicipalityTasksApi.updateStatusTask({ taskName: name }).then(() => getMunicipalityTasks());
  };
  return (
    <Context.Provider value={{ values, updateMunicipalityTask, addModal, closeModal, currentModal, id, userType }}>
      {props.children}
    </Context.Provider>
  );
};

export const useMunicipalityTasks = () => useContext(Context);
export default MunicipalityTasksContext;
